import React, { useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Button,
  IconButton,
  InputAdornment,
  TableBody,
  TextField,
  Typography,
} from "@mui/material";

import {
  getSupplierCategories,
  getCountries,
  getStates,
  globalFilter,
} from "../../../../component/cellRenderers/renderers";
import { setAlertTitleText } from "../../../../component/modal/alertModal";

import {
  SPANISH_GREEN,
  WHITE,
} from "../../../../resources/constant/colors/theme";
import { isValidEmail } from "../../../../resources/constant/utilities/util";

import { APIMASTER } from "../../../../apihandler/master";

import "./modal.css";


function Modal({
  setOpenModal,
  model,
  formTitle,
  updateModel,
  addModel,
  viewModel,
}) {
  const onFormSubmit = (e) => {
    e.preventDefault();
    validation();
    //
  };
  function validation() {
    if (errorEmail) {
      setErrorEmail("Enter a valid Email");
      return;
    }
    if (errorMobile) {
      setErrorMobile("Enter a valid Number");
      return;
    }
    if (dto.countryId <= 0 || dto.stateId <= 0) {
      setAlertTitleText("Oops...", `Please select state and country`);
      return;
    }

    if (dto.id <= 0)
      APIMASTER.AddSupplier(dto)
        .then((response) => response.json())
        .then((data) => {
          if (data.statusCode === 200) {
            addModel(data.response);
            setAlertTitleText(
              "Success",
              "The record was inserted successfully"
            );
            setOpenModal(false);
          } else {
            setAlertTitleText(
              "Oops...",
              `Something went wrong... ${data.message}`
            );
          }
        });
    else
      APIMASTER.UpdateSupplier(dto.id, dto)
        .then((response) => response.json())
        .then((data) => {
          if (data.statusCode === 200) {
            updateModel(data.response);
            setAlertTitleText("Success", "The record was updated successfully");
            setOpenModal(false);
          } else {
            setAlertTitleText(
              "Oops...",
              `Something went wrong...${data.message}`
            );
          }
        });
  }
  const categoryItems = getSupplierCategories();
  const countries = getCountries();
  const states = getStates();

  const [errorEmail, setErrorEmail] = useState("");
  const [errorMobile, setErrorMobile] = useState("");

  const [dto, setDTO] = useState(model);

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (value) {
      if (
        isNaN(value) ||
        name === "phone" ||
        name === "mobile" ||
        name === "pin" ||
        name === "accountNo" ||
        name === "panNo" ||
        name === "rtgsCode" ||
        name === "gst" ||
        name === "address1" ||
        name === "address2" ||
        name === "address3" ||
        name === "sstGst"
      )
        setDTO({ ...dto, [name]: value });
      else setDTO({ ...dto, [name]: Number(value) });
    } else {
      setDTO({ ...dto, [name]: value });
    }
  };

  const categoryProps = {
    options: categoryItems,
    getOptionLabel: (option) => option?.name || "",
  };

  const countryProps = {
    options: countries,
    getOptionLabel: (option) => option?.name || "",
  };

  const stateProps = {
    options: states,
    getOptionLabel: (option) => option?.name || "",
  };

  return (
    <div className="modalBackgroundForSuppliers">
      {/* div for top right close button */}
      <form>
        <div style={{ display: "flex", flexDirection: "row-reverse" }}>
          <IconButton
            style={{ width: "auto", align: "center", marginRight: 5 }}
            onClick={() => setOpenModal(false)}
          >
            <CloseIcon />
          </IconButton>
        </div>
        {/* top right close button div closed */}

        <div
          style={{
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            width: "100%",
          }}
        >
          <table style={{ width: "100%", margin: 5 }}>
            <TableBody>
              <tr>
                <td>
                  <Typography
                    fontSize={18}
                    fontWeight={600}
                    fontspacing={"normal"}
                    textTransform="capitalize"
                    align="left"
                  >
                    {formTitle}
                  </Typography>
                </td>
              </tr>
              <tr>
                <td>
                  <TextField
                    variant="standard"
                    label="Supplier Code"
                    disabled
                    style={{
                      minWidth: "200px",
                      width: "200px",
                      minHeight: "48.5px",
                    }}
                    name="supplierCode"
                    value={dto.supplierCode}
                    onChange={handleInputChange}
                    InputLabelProps={{
                      style: { color: "grey" },
                    }}
                  ></TextField>
                </td>
                <td>
                  <TextField
                    inputProps={{
                      maxlength: 128,
                    }}
                    variant="standard"
                    label="Supplier Name"
                    disabled={viewModel}
                    required
                    style={{
                      minWidth: "200px",
                      minHeight: "48.5px",
                      width: "200px",
                    }}
                    name="supplierName"
                    value={dto.supplierName}
                    onChange={handleInputChange}
                    InputLabelProps={{
                      style: { color: "grey" },
                    }}
                  ></TextField>
                </td>
                <td>
                  <Autocomplete
                    filterOptions={globalFilter}
                    {...categoryProps}
                    id="auto-complete-1"
                    autoComplete
                    autoHighlight
                    autoSelect
                    includeInputInList
                    disabled={viewModel}
                    name="categoryId"
                    defaultValue={
                      categoryProps.options.find(
                        (v) => v.value === dto.categoryId
                      ) || {}
                    }
                    onChange={(e, v) => {
                      if (v) {
                        if (isNaN(v?.value))
                          setDTO({ ...dto, categoryId: v?.value });
                        else setDTO({ ...dto, categoryId: Number(v?.value) });
                      } else {
                        setDTO({ ...dto, categoryId: v?.value });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Category"
                        disabled={viewModel}
                        variant="standard"
                        required
                        style={{
                          minWidth: "200px",
                          minHeight: "48.5px",
                          width: "200px",
                          height: "48.5px",
                        }}
                        InputLabelProps={{
                          style: { color: "grey" },
                        }}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <TextField
                    inputProps={{
                      maxlength: 128,
                    }}
                    variant="standard"
                    label="Address 1"
                    disabled={viewModel}
                    required
                    style={{
                      minWidth: "200px",
                      minHeight: "48.5px",
                      width: "200px",
                    }}
                    name="address1"
                    value={dto.address1}
                    onChange={handleInputChange}
                    InputLabelProps={{
                      style: { color: "grey" },
                    }}
                  ></TextField>
                </td>
                <td>
                  <TextField
                    inputProps={{
                      maxlength: 128,
                    }}
                    variant="standard"
                    label="Address 2"
                    disabled={viewModel}
                    name="address2"
                    style={{
                      minWidth: "200px",
                      minHeight: "48.5px",
                      width: "200px",
                    }}
                    value={dto.address2}
                    onChange={handleInputChange}
                    InputLabelProps={{
                      style: { color: "grey" },
                    }}
                  ></TextField>
                </td>
                <td>
                  <TextField
                    inputProps={{
                      maxlength: 128,
                    }}
                    variant="standard"
                    label="Address 3"
                    disabled={viewModel}
                    name="address3"
                    style={{
                      minWidth: "200px",
                      minHeight: "48.5px",
                      width: "200px",
                    }}
                    value={dto.address3}
                    onChange={handleInputChange}
                    InputLabelProps={{
                      style: { color: "grey" },
                    }}
                  ></TextField>
                </td>
              </tr>
              <tr>
                <td>
                  <TextField
                    inputProps={{
                      maxlength: 128,
                    }}
                    variant="standard"
                    disabled={viewModel}
                    label="City"
                    name="city"
                    style={{
                      minWidth: "200px",
                      width: "200px",
                      minHeight: "48.5px",
                    }}
                    value={dto.city}
                    onChange={handleInputChange}
                    InputLabelProps={{
                      style: { color: "grey" },
                    }}
                  ></TextField>
                </td>

                <td>
                  <Autocomplete
                    filterOptions={globalFilter}
                    {...stateProps}
                    disabled={viewModel}
                    id="auto-complete-2"
                    autoComplete
                    autoHighlight
                    autoSelect
                    includeInputInList
                    name="stateId"
                    defaultValue={
                      stateProps.options.find((v) => v.value === dto.stateId) ||
                      {}
                    }
                    onChange={(e, v) => {
                      if (v) {
                        if (isNaN(v.value))
                          setDTO({
                            ...dto,
                            stateId: v.value,
                            countryId: v.dependentvalue,
                          });
                        else
                          setDTO({
                            ...dto,
                            stateId: Number(v.value),
                            countryId: Number(v.dependentvalue),
                          });
                      } else {
                        setDTO({
                          ...dto,
                          stateId: v?.value,
                          countryId: v?.dependentvalue,
                        });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        disabled={viewModel}
                        label="State"
                        variant="standard"
                        style={{
                          minWidth: "200px",
                          minHeight: "48.5px",
                          width: "200px",
                          height: "48.5px",
                        }}
                        InputLabelProps={{
                          style: { color: "grey" },
                        }}
                      />
                    )}
                  />
                </td>
                <td>
                  <Autocomplete
                    filterOptions={globalFilter}
                    {...countryProps}
                    id="auto-complete-3"
                    disabled={true}
                    autoComplete
                    autoHighlight
                    autoSelect
                    includeInputInList
                    name="countryId"
                    value={
                      countryProps.options.find(
                        (v) => v.value === dto.countryId
                      ) || {}
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        disabled={viewModel}
                        label="Country"
                        variant="standard"
                        style={{
                          minWidth: "200px",
                          minHeight: "48.5px",
                          width: "200px",
                          height: "48.5px",
                        }}
                        InputLabelProps={{
                          style: { color: "grey" },
                        }}
                      />
                    )}
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <TextField
                    inputProps={{
                      maxlength: 16,
                    }}
                    variant="standard"
                    label="PIN"
                    disabled={viewModel}
                    name="pin"
                    style={{
                      minWidth: "200px",
                      width: "200px",
                      minHeight: "48.5px",
                    }}
                    value={dto.pin}
                    onChange={handleInputChange}
                    InputLabelProps={{
                      style: { color: "grey" },
                    }}
                  ></TextField>
                </td>
                <td>
                  <TextField
                    inputProps={{
                      maxlength: 128,
                    }}
                    variant="standard"
                    label="Email ID"
                    disabled={viewModel}
                    style={{
                      minWidth: "200px",
                      width: "200px",
                      minHeight: "48.5px",
                    }}
                    name="email"
                    helperText={errorEmail}
                    error={!!errorEmail}
                    value={dto.email}
                    onChange={(e, v) => {
                      if (!isValidEmail(e.target.value)) {
                        setErrorEmail("Enter valid email");
                      } else {
                        setErrorEmail("");
                      }
                      handleInputChange(e, v);
                    }}
                    InputLabelProps={{
                      style: { color: "grey" },
                    }}
                  ></TextField>
                </td>
                <td>
                  <TextField
                    variant="standard"
                    label="Ph no"
                    disabled={viewModel}
                    style={{
                      minWidth: "200px",
                      width: "200px",
                      minHeight: "48.5px",
                    }}
                    name="phone"
                    value={dto.phone}
                    onChange={handleInputChange}
                    InputLabelProps={{
                      style: { color: "grey" },
                    }}
                  ></TextField>
                </td>
              </tr>
              <tr>
                <td>
                  <TextField
                    variant="standard"
                    label="MOB"
                    disabled={viewModel}
                    style={{
                      minWidth: "200px",
                      minHeight: "48.5px",
                      width: "200px",
                    }}
                    name="mobile"
                    value={dto.mobile}
                    helperText={errorMobile}
                    error={!!errorMobile}
                    onChange={(e, v) => {
                      if (e.target.value.length !== 10) {
                        setErrorMobile("Enter a valid mobile number");
                      } else {
                        setErrorMobile("");
                      }
                      handleInputChange(e, v);
                    }}
                    InputLabelProps={{
                      style: { color: "grey" },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">+91</InputAdornment>
                      ),
                    }}
                  ></TextField>
                </td>
                <td>
                  <TextField
                    inputProps={{
                      maxlength: 128,
                    }}
                    variant="standard"
                    label="PAN"
                    disabled={viewModel}
                    style={{
                      minWidth: "200px",
                      minHeight: "48.5px",
                      width: "200px",
                    }}
                    name="panNo"
                    value={dto.panNo}
                    onChange={handleInputChange}
                    InputLabelProps={{
                      style: { color: "grey" },
                    }}
                  ></TextField>
                </td>
                <td>
                  <TextField
                    inputProps={{
                      maxlength: 16,
                    }}
                    variant="standard"
                    label="GST no"
                    disabled={viewModel}
                    style={{
                      minWidth: "200px",
                      width: "200px",
                      minHeight: "48.5px",
                    }}
                    name="sstGst"
                    value={dto.sstGst}
                    onChange={handleInputChange}
                    InputLabelProps={{
                      style: { color: "grey" },
                    }}
                  ></TextField>
                </td>
              </tr>
              <tr>
                <td>
                  <TextField
                    inputProps={{
                      maxlength: 16,
                    }}
                    variant="standard"
                    label="Account no"
                    disabled={viewModel}
                    style={{
                      minWidth: "200px",
                      width: "200px",
                      minHeight: "48.5px",
                    }}
                    name="accountNo"
                    value={dto.accountNo}
                    onChange={handleInputChange}
                    InputLabelProps={{
                      style: { color: "grey" },
                    }}
                  ></TextField>
                </td>
                <td>
                  <TextField
                    inputProps={{
                      maxlength: 128,
                    }}
                    variant="standard"
                    label="Bank Name"
                    disabled={viewModel}
                    style={{
                      minWidth: "200px",
                      width: "200px",
                      minHeight: "48.5px",
                    }}
                    name="bankName"
                    value={dto.bankName}
                    onChange={handleInputChange}
                    InputLabelProps={{
                      style: { color: "grey" },
                    }}
                  ></TextField>
                </td>
                <td>
                  <TextField
                    inputProps={{
                      maxlength: 128,
                    }}
                    variant="standard"
                    label="Branch Name"
                    disabled={viewModel}
                    style={{
                      minWidth: "200px",
                      width: "200px",
                      minHeight: "48.5px",
                    }}
                    name="branchName"
                    value={dto.branchName}
                    onChange={handleInputChange}
                    InputLabelProps={{
                      style: { color: "grey" },
                    }}
                  ></TextField>
                </td>
              </tr>
              <tr>
                <td>
                  <TextField
                    inputProps={{
                      maxlength: 16,
                    }}
                    variant="standard"
                    label="RTGS Code"
                    disabled={viewModel}
                    style={{
                      minWidth: "200px",
                      width: "200px",
                      minHeight: "48.5px",
                    }}
                    name="rtgsCode"
                    value={dto.rtgsCode}
                    onChange={handleInputChange}
                    InputLabelProps={{
                      style: { color: "grey" },
                    }}
                  ></TextField>
                </td>
                <td>
                  <TextField
                    inputProps={{
                      maxlength: 128,
                    }}
                    variant="standard"
                    label="Contact Person"
                    disabled={viewModel}
                    style={{
                      minWidth: "200px",
                      width: "200px",
                      minHeight: "48.5px",
                    }}
                    name="contactPerson"
                    value={dto.contactPerson}
                    onChange={handleInputChange}
                    InputLabelProps={{
                      style: { color: "grey" },
                    }}
                  ></TextField>
                </td>
              </tr>
            </TableBody>
          </table>
        </div>

        {/* div for buttons */}
        {!viewModel ? (
          <div
            style={{
              justifyContent: "center",
              alignContent: "center",
              alignItems: "center",
              display: "flex",
              marginTop: 10,
            }}
          >
            <Button
              variant="outlined"
              sx={{
                borderColor: SPANISH_GREEN,
              }}
              style={{
                textTransform: "capitalize",
                fontSize: 14,
                color: SPANISH_GREEN,
                minWidth: "180px",
                minHeight: "45px",
                margin: 10,
              }}
              onClick={() => {
                setOpenModal(false);
              }}
            >
              Cancel
            </Button>
            <Button
              style={{
                backgroundColor: SPANISH_GREEN,
                textTransform: "capitalize",
                fontSize: 14,
                color: WHITE,
                minWidth: "180px",
                minHeight: "45px",
                margin: 10,
              }}
              onClick={onFormSubmit}
            >
              Save
            </Button>
          </div>
        ) : (
          <div />
        )}
        {/* div for buttons closed */}
      </form>
      {/* pop up div closed  */}
    </div>
  );
}

export default Modal;
